import React from "react";
import PageContainer from "../../components/PageContainer";
import "./style.scss";

export default () => {
    return (
        <PageContainer>
            <div className={"page-block ui-kit"}>
                <h1>Заголовок 1</h1>
                <h2>Заголовок 1</h2>
                <h3>Заголовок 1</h3>
                <h4>Заголовок 1</h4>
                <h5>Заголовок 1</h5>
                <h6>Заголовок 1</h6>
                <form>
                    <article>
                        <label>input</label>
                        <div><input /></div>
                    </article>
                    <article>
                        <label>input type="text"</label>
                        <div><input type="text" defaultValue={'Поле с текстом'} /></div>
                    </article>
                    <article>
                        <label>input type="password"</label>
                        <div><input type="password" defaultValue={'pass'} /></div>
                    </article>
                    <article>
                        <label>input type="file"</label>
                        <div><input type="file" /></div>
                    </article>
                    <article>
                        <label>input type="checkbox"</label>
                        <div>
                            <label>
                                <input type="checkbox" defaultValue={'pass'} />
                                Checkbox
                            </label>
                        </div>
                        <div>
                            <label>
                                <input type="checkbox" defaultValue={'pass'} />
                                Checkbox
                            </label>
                        </div>
                    </article>
                    <article>
                        <label>input type="radio"</label>
                        <div>
                            <label>
                                <input type="radio" name={'radio'} defaultChecked />
                                Radio 1
                            </label>
                        </div>
                        <div>
                            <label>
                                <input type="radio" name={'radio'} />
                                Radio 2
                            </label>
                        </div>
                    </article>
                    <article>
                        <label>select</label>
                        <div>
                            <select>
                                <option value={'1'}>Option 1</option>
                                <option value={'2'}>Option 2</option>
                                <option value={'3'}>Option 3</option>
                            </select>
                        </div>
                    </article>
                    <article>
                        <label>select multiple</label>
                        <div>
                            <select multiple>
                                <option value={'1'}>Option 1</option>
                                <option value={'2'}>Option 2</option>
                                <option value={'3'}>Option 3</option>
                            </select>
                        </div>
                    </article>
                    <article>
                        <label>textarea</label>
                        <div>
                            <textarea defaultValue={'Textarea'} />
                        </div>
                    </article>
                    <article>
                        <label>button</label>
                        <div>
                            <button>Button</button>
                        </div>
                    </article>
                    <article>
                        <label>button type="submit"</label>
                        <div>
                            <button type={"submit"}>Button</button>
                        </div>
                    </article>
                    <article>
                        <label>button type="reset"</label>
                        <div>
                            <button type={"reset"}>Button</button>
                        </div>
                    </article>
                </form>
            </div>
        </PageContainer>
    );
}
